// Lazy-loads the full design font library. Core UI fonts (Outfit/Manrope/Inter)
// ship in index.css for fast first paint; everything else loads on demand
// (when the editor or a shared design mounts) to keep initial load light.

const DESIGN_FONT_URLS = [
  "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=Bebas+Neue&family=Montserrat:wght@400;600;700;800;900&family=Oswald:wght@400;500;700&family=Poppins:wght@400;500;600;700;800&family=Anton&family=Pacifico&family=Lobster&family=Dancing+Script:wght@400;700&family=Archivo+Black&family=Caveat:wght@400;700&family=Roboto+Slab:wght@400;600;800&family=Orbitron:wght@400;700;900&family=Bungee&family=Fredoka:wght@400;600;700&family=Audiowide&family=Monoton&family=Press+Start+2P&family=VT323&family=Rye&family=Permanent+Marker&family=Staatliches&display=swap",
  "https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700;900&family=Lora:ital,wght@0,400;0,600;1,400&family=EB+Garamond:ital,wght@0,400;0,600;1,400&family=Bodoni+Moda:ital,wght@0,400;0,700;0,900&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Libre+Caslon+Display&family=Cormorant+Garamond:wght@400;600;700&family=League+Gothic&family=Yellowtail&family=Allura&family=Great+Vibes&family=Sacramento&family=Raleway:wght@400;500;600;700;800;900&family=Roboto:wght@400;500;700;900&family=Jost:wght@400;500;700;900&display=swap",
];

let loaded = false;

export function loadDesignFonts() {
  if (loaded || typeof document === "undefined") return;
  loaded = true;
  DESIGN_FONT_URLS.forEach((href, i) => {
    const id = `design-fonts-${i}`;
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  });
}
